<template>
  <div>
    <button
      @click="openModal('modal')"
      type="button"
      class="transition duration-300 ease-in-out focus:outline-none text-white text-xs py-2 px-3 rounded focus:shadow-focus bg-indigo-600"
    >
      <font-awesome-icon icon="plus" class="mr-2" />
      Nova categoria
    </button>

    <ui-modal ref="modal" title="Categorias">
      <form action="" @submit.prevent="doStoreCategories" method="post">
        <div class="w-full p-2">
          <input-icon
            :icon="{ name: 'tag', type: 'solid' }"
            id="category_name"
            name="category_name"
            type="text"
            v-model="name"
            label="Nome:"
          ></input-icon>
        </div>
        <div class="w-full p-2">
          <input-icon
            :icon="{ name: 'info-square', type: 'solid' }"
            id="category_description"
            name="category_description"
            type="text"
            v-model="description"
            label="description:"
          ></input-icon>
        </div>
        <div class="w-full p-2">
          <button-icon icon="plus" text="Adicionar" class="bg-indigo-600" />
        </div>
      </form>
    </ui-modal>
  </div>
</template>

<script>
export default {
  props: {
    store_id: String
  },
  watch: {
    show(newValue, OldValue) {
      if (newValue) {
        this.openModal('modal1')
      }
    }
  },
  data() {
    return {
      name: '',
      description: '',
      slug: '',
      categories: {}
    }
  },
  methods: {
    openModal(ref) {
      this.$refs[ref].open()
      this.name = ''
      this.description = ''
    },
    closeModal(ref) {
      this.$refs[ref].close()
      this.show = false
    },
    doStoreCategories() {
      const data = {
        store_id: this.store_id,
        name: this.name,
        description: this.description
      }
      this.$store
        .dispatch('store/CREATE_CATEGORIES_BY_STORE', data)
        .then(response => {
          this.$toasted.success(response.data.message, {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
          this.$emit('created', response.data.data)
          this.closeModal('modal')
        })
        .catch(error => {
          const msg = Object.values(error.data.errors)
          msg.forEach((item, i) => {
            this.$toasted.error(item, {
              position: 'top-center',
              duration: 5000,
              icon: 'close'
            })
          })
        })
    }
  }
}
</script>

<style></style>
